var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteH2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-428.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-h2",
    transform: "translate(429.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30769231,5 L7.19230769,5",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.625 L1.96153846,0.625",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.375 L1.96153846,9.375",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.980769231,0.9375 L0.980769231,9.0625",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53846154,0.625 L8.5,0.625",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53846154,9.375 L8.5,9.375",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51923077,0.9375 L7.51923077,9.0625",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7307692,2.5 C15.4405769,2.5 16.5841538,3.375625 16.5841538,4.66625 C16.5841538,5.47625 16.0865769,6.194375 14.7311538,7.348125 L13.4711923,8.45625 L13.4711923,8.5525 L16.6900769,8.5525 L16.6900769,10 L10.8819615,10 L10.8819615,8.76 L13.2959615,6.58875 C14.4186154,5.596875 14.7043462,5.2275 14.7043462,4.7975 C14.7043462,4.26125 14.2911154,3.901875 13.6614615,3.901875 C13.005,3.901875 12.5499231,4.326875 12.5499231,4.929375 L12.5499231,4.965 L10.7708077,4.965 L10.7708077,4.934375 C10.7714615,3.481875 11.9568846,2.5 13.7307692,2.5 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteH2);
export default __webpack_public_path__ + "static/media/icon-rte-h2.f263de20ebbe8c66f33544799f7f17e9.svg";
export { ForwardRef as ReactComponent };